import { useMediaQuery } from "@mui/material";

export const useAdminPage = () => {
  const isLargeScreen = useMediaQuery("(min-width:1000px)");

  return {
    isLargeScreen,
  };
};
